'use client'

import { ZapIcon } from 'lucide-react'

import { AccountBanner } from '~/components/account-detail/AccountBanner'
import { Skeleton } from '~/components/component-library/Skeleton'
import { EnableAutoEarnDialogContent } from '~/components/forms/earn/EnableAutoEarnDialog'
import { useAutoEarnToggle } from '~/components/forms/earn/useAutoEarnToggle'
import { useAuth } from '~/context/AuthProvider'
import { useActiveOrg } from '~/hooks/org'
import { useAutoEarnApy } from '~/hooks/useAutoEarnApy'
import { useNavigation } from '~/hooks/useNavigation'
import { OrgSmartAccount } from '~/types'
import { getEarnLabel } from '~/utils/vault'

export const EarnApyBanner = ({
  smartAccount,
}: {
  smartAccount: OrgSmartAccount
}) => {
  const { apy, isLoading: isApyLoading } = useAutoEarnApy()
  const { setGlobalModalState, closeGlobalModal } = useAuth()
  const navigate = useNavigation()
  const { featureFlags } = useActiveOrg()
  // Workspace auto-earn is turned on in Settings > General, not per account
  const isWorkspaceAutoEarn = !!featureFlags?.['workspace-auto-earn']
  // Signer-gated like every auto-earn surface; blocked clicks keep the normal look
  const { isDisabled, disabledReason } = useAutoEarnToggle(smartAccount, {
    enabled: !isWorkspaceAutoEarn,
  })

  return (
    <AccountBanner
      icon={<ZapIcon className="h-6 w-6 text-white" />}
      title={
        isApyLoading ? (
          <div className="flex items-center space-x-1">
            <div>Earn</div> <Skeleton size="sm" length={3} height={0.5} />
          </div>
        ) : (
          getEarnLabel(apy)
        )
      }
      description="Auto-deposit your idle USDC"
      isDisabled={!isWorkspaceAutoEarn && isDisabled}
      disabledReason={disabledReason}
      onClick={() => {
        if (isWorkspaceAutoEarn) {
          navigate('/settings/team/general')
          return
        }
        setGlobalModalState({
          isOpen: true,
          content: (
            <EnableAutoEarnDialogContent
              smartAccount={smartAccount}
              closeDialog={closeGlobalModal}
            />
          ),
        })
      }}
    />
  )
}
